<page-loader>
  <div class="mat-dialog-header">
    <div mat-dialog-title>
      Change password
    </div>
  </div>
  <div mat-dialog-content>
    <form [formGroup]="form" class="d-flex flex-column">
      <mat-form-field floatLabel="" class="mt-3" appearance="outline">
        <mat-label>Current password</mat-label>
        <input #email
               matInput
               placeholder="Current password"
               value=""
               name="oldPassword"
               required
               type="password"
               autocomplete="on"
               formControlName="oldPassword">
      </mat-form-field>
      <mat-form-field floatLabel="" [ngClass]="form?.get('newPassword').errors?.password ? 'mb-3' : ''" appearance="outline">
        <mat-label>New password</mat-label>
        <input #email
               matInput
               placeholder="New password"
               value=""
               name="newPassword"
               required
               type="password"
               formControlName="newPassword"
               [errorStateMatcher]="errorStateMatcher">
        <mat-error *ngIf="form?.get('newPassword').errors?.password">Password must be min. 8 characters long and have at least one upper case, digit and special character</mat-error>
      </mat-form-field>
      <mat-form-field floatLabel="" [ngClass]="form?.get('confirmPassword').errors?.password && form?.get('confirmPassword').errors?.compare ? 'mb-5' : (form?.get('confirmPassword').errors?.password ? 'mb-3' : '')" appearance="outline">
        <mat-label>Confirm password</mat-label>
        <input #email
               matInput
               placeholder="Confirm password"
               value=""
               name="confirmPassword"
               required
               type="password"
               formControlName="confirmPassword"
               [errorStateMatcher]="errorStateMatcher">
        <mat-error *ngIf="form?.get('confirmPassword').errors?.password">Password must be min. 8 characters long and have at least one upper case, digit and special character</mat-error>
        <mat-error *ngIf="form?.get('confirmPassword').errors?.compare">Passwords do not match!</mat-error>
      </mat-form-field>
    </form>
  </div>
  <div mat-dialog-actions class="justify-content-end">
    <button mat-flat-button class="mr-3" [mat-dialog-close]="false">
      Cancel
    </button>
    <button mat-flat-button color="primary" [disabled]="form.invalid" (click)="save()">
      Save
    </button>
  </div>
</page-loader>
